import { Navigate, Route } from "react-router-dom";
import { ListReport } from "../components";

const listRoutes = [
    <Route index element={<Navigate to="list" replace />} key={"list:index"} />,
    <Route path="list" element={<ListReport />} key={"list"} />,
];
export default listRoutes;
